import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";

// Icon Imports
import { MdHome, MdPerson } from "react-icons/md";
import UsersOverview from "views/admin/users";
import AboutUs from "views/cms/AboutUs";
import PrivacyPolicy from "views/cms/PrivacyPolicy";
import TermsAndConditions from "views/cms/TermsAndConditions";
import FAQ from "views/cms/FAQ";
import FooterCMS from "views/cms/FooterCMS";
import ContactUs from "views/cms/ContactUs";
import HomeBanner from "views/cms/HomeBanner";
import ContactUsList from "views/cms/ContactUsList";
import Features from "views/cms/Features";
import HowItWorks from "views/cms/HowItWorks";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "User Management",
    layout: "/admin",
    path: "users",
    icon: <MdPerson className="h-6 w-6" />,
    component: <UsersOverview />,
  },
  {
    name: "CMS",
    layout: "/admin",
    path: "about-us",
    icon: <MdPerson className="h-6 w-6" />,
    component: <AboutUs />,
    children: [
      {
        name: "About Us",
        layout: "/admin",
        path: "about-us",
        component: <AboutUs />,
      },
      {
        name: "Contact Us",
        layout: "/admin",
        path: "contact-us",
        component: <ContactUs />,
      },
      {
        name: "Contact Us List",
        layout: "/admin",
        path: "list",
        component: <ContactUsList />,
      },
      {
        name: "FAQ",
        layout: "/admin",
        path: "faq",
        component: <FAQ />,
      },
      {
        name: "Features",
        layout: "/admin",
        path: "features",
        component: <Features />,
      },
      {
        name: "Footer",
        layout: "/admin",
        path: "footer",
        component: <FooterCMS />,
      },
      {
        name: "Home Banner",
        layout: "/admin",
        path: "home-banner",
        component: <HomeBanner />,
      },
      {
        name: "How It Works",
        layout: "/admin",
        path: "how-it-works",
        component: <HowItWorks />,
      },
      {
        name: "Privacy Policy",
        layout: "/admin",
        path: "privacy-policy",
        component: <PrivacyPolicy />,
      },
      {
        name: "Terms And Conditions",
        layout: "/admin",
        path: "terms-and-conditions",
        component: <TermsAndConditions />,
      },
    ],
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
];
export default routes;
